export default "__VITE_ASSET__15beba01__"